import { ImageLoader } from 'next/image';

const myImageLoader: ImageLoader = ({ src, width, quality }) => {
  return src; // 这里需要返回完整的 URL 字符串
};

export default myImageLoader;
